import React from 'react';
import TimerDisplay from './TimerDisplay';
import { getModelDisplayName } from '../constants/modelConstants';

type GameActiveProps = {
  modelName: string;
  modelTimeRemaining: number;
  playerTimeRemaining: number;
  activePlayer: 'player' | 'model';
  onResign: () => void;
};

const GameActive: React.FC<GameActiveProps> = ({
  modelName,
  modelTimeRemaining,
  playerTimeRemaining,
  activePlayer,
  onResign,
}) => (
  <div className="flex flex-col gap-4">
    <TimerDisplay 
      label={getModelDisplayName(modelName)}
      timeRemaining={modelTimeRemaining}
      isActive={activePlayer === 'model'}
    />
    <div className="border-t border-terminal-green/30 my-2"></div>
    <TimerDisplay 
      label="Player 1"
      timeRemaining={playerTimeRemaining}
      isActive={activePlayer === 'player'}
    />
    <button
      className="w-full rounded mt-4 bg-bg-dark text-terminal-green border border-terminal-green p-3 font-vt323 text-xl cursor-pointer hover:bg-dark-green"
      onClick={onResign}
    >
      $ RESIGN
    </button>
  </div>
);

export default GameActive;
